import { FaMousePointer, FaShoppingBasket, FaTachometerAlt, FaUsers } from "react-icons/fa";
import { FaUser } from "react-icons/fa6";
import { Navigate } from "react-router-dom";

import type { MainSectionType } from "../components/layout/sideBar/menuItem/types";

/*This is the Main Section ARRAY populate this to populate the main nav menu
It is also used to create all the Routes for the router*/
export const mainSections: MainSectionType[] = [
  {
    label: "Artesian",
    path: "",
    subsections: [
      {
        path: "",
        label: "index",
        isInMenu: false,
        component: <Navigate to="/home" />,
        authenticatedOnly: true,
      },
      {
        path: "home",
        label: "Search Page",
        icon: FaMousePointer,
        isInMenu: true,
        lazy: async () => import("../features/home/home"),
      },
      {
        path: "basket",
        label: "Basket",
        icon: FaShoppingBasket,
        isInMenu: true,
        lazy: async () => import("../features/basketPage/basketPage"),
        disabled: false,
      },
      {
        path: "expectationAlert",
        label: "Expectation Monitor",
        icon: FaTachometerAlt,
        isInMenu: true,
        lazy: async () => import("../features/expectationAlert/expectationAlertPage"),
      },
      {
        path: "users",
        label: "Users",
        icon: FaUser,
        isInMenu: false,
        lazy: async () => import("../features/admin/usersPage"),
      },
      {
        path: "groups",
        label: "Groups",
        icon: FaUsers,
        isInMenu: false,
        lazy: async () => import("../features/admin/groupsPage"),
      },
      {
        path: "classify",
        label: "Classify",
        icon: FaUsers,
        isInMenu: false,
        lazy: async () => import("../features/classifications/classificationsPage"),
      },
      {
        path: "enrichMetaData",
        label: "Enrich MetaData",
        icon: FaUsers,
        isInMenu: false,
        lazy: async () => import("../features/enrichMetaData/enrichMetaDataPage"),
      },
      {
        path: "extraction",
        label: "Extraction",
        isInMenu: false,
        lazy: async () => import("../features/extraction/extractionPage"),
        disabled: false,
      },
      {
        path: "timeTransforms",
        label: "timeTransforms",
        isInMenu: false,
        lazy: async () => import("../features/timeTransforms/timeTransformsPage"),
        disabled: false,
      },
    ],
  },
];
